import { render } from "./AboutPage.vue?vue&type=template&id=00a1f886&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=00a1f886&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a1f886"]])

export default __exports__